export default ({ shouldSpeakIncomingActivity }) => shouldSpeakIncomingActivity;
